export const formatPrice = (price, keepCents = false) => {
  let formatted = price

  if (!keepCents) {
    formatted = price.toString().replace(/\.00$/,'')
  }

  formatted = formatted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return formatted
}
